import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@material-ui/core';


const ConfirmDialog = ({ title, children, open, setOpen, onConfirm, onClose = null }) => (
  <Dialog
    open={open}
    onClose={() => setOpen(false)}
    aria-labelledby="confirm-dialog"
  >
    <DialogTitle id="confirm-dialog">{title}</DialogTitle>
    <DialogContent>{children}</DialogContent>
    <DialogActions>
      <Button
        variant="contained"
        onClick={() => {
          setOpen(false);
          onClose();
        }}
        color="secondary"
      >
        No
      </Button>
      <Button
        variant="contained"
        onClick={() => {
          setOpen(false);
          onConfirm();
        }}
      >
        Yes
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDialog;
